export default {
      id: "arrow_left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#arrow_left-usage",
      toString: function () {
        return this.url;
      }
    }